module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipe-wrap"
  }, [_c('div', {
    staticClass: "swipe"
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('CarouselItem', {
      key: item.key
    }, [_c('div', {
      style: (_vm.styleObject)
    }, [_c('router-link', {
      attrs: {
        "to": item.url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "scrollLoading",
      attrs: {
        "src": item.atturl,
        "alt": item.aname
      }
    })])], 1)])
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-686a1aca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/self-owned-mall/index/banner.vue
// module id = 1625
// module chunks = 1